module.exports = __webpack_public_path__ + "static/media/Exercise.77176e5c.png";